import React from "react";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Section from "../components/Section";
import Cloud from "../components/Cloud";
import IconButton from "../components/IconButton";
import { SOCIAL_LINKS } from "../utils/constants";
import { useScrollToSection } from "../hooks/useScrollToSection";

const AboutSection = () => {
  const { t } = useTranslation();
  const scrollToContact = useScrollToSection('contact');

  return (
    <Section
      id="about"
      className="overflow-hidden mt-16 min-h-screen bg-transparent"
      showTimestamp={false}
    >
      {/* Background */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-[rgba(147,197,253,0.8)] to-[rgba(191,219,254,0.8)] dark:from-[rgba(30,58,138,0.4)] dark:to-[rgba(30,58,138,0.2)] -z-8">
        <div className="relative w-full h-full">
          <Cloud className="top-1/4 w-32 h-10 animate-float-slow" />
          <Cloud className="top-1/3 w-28 h-8 delay-1000 animate-float-slower" />
          <Cloud className="top-2/4 w-36 h-12 animate-float-slowest delay-2000" />
          <Cloud className="top-3/4 w-24 h-8 animate-float-slow delay-3000" />
          <Cloud className="w-32 h-10 top-[15%] animate-float-slower delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="z-30 flex-grow">
        {/* Profile Section */}
        <div className="flex flex-col items-center space-y-6 md:flex-row md:items-start md:space-y-0">
          {/* Profile Picture */}
          <div className="flex-shrink-0 p-1 w-52 h-52 bg-gradient-to-r from-blue-500 to-blue-300 rounded-full">
            <img
              src="/profile-pic-cropped.jpg"
              alt="Profile"
              className="object-cover w-full h-full rounded-full"
            />
          </div>

          {/* Info */}
          <div className="w-full text-center md:ml-8">
            <h1 className="mt-4 text-5xl md:text-6xl">John Linthicum</h1>
            <p className="text-xl text-secondary">
              {t("position")},{" "}
              <a
                href={SOCIAL_LINKS.UNIVERSITY}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500"
              >
                {t("university")}
              </a>
            </p>
            
            <div className="flex justify-center items-center mt-2 text-secondary">
              <LocationOnIcon className="mr-1" />
              <span>Frankfurt, Germany</span>
            </div>

            {/* Social Links */}
            <div className="flex justify-center pt-4 mt-4 space-x-8 w-full border-t-2 sm:space-x-16 lg:space-x-36 border-border-secondary">
              <IconButton Icon={HomeIcon} href="#about" />
              <IconButton Icon={EmailIcon} href="#contact" />
              <IconButton Icon={GitHubIcon} href={SOCIAL_LINKS.GITHUB} external />
              {/* <IconButton Icon={LinkedInIcon} href={SOCIAL_LINKS.LINKEDIN} external /> */}
            </div>
          </div>
        </div>

        {/* About Text */}
        <div className="p-6 mt-6 rounded-lg border shadow-md bg-background border-secondary">
          <p className="leading-relaxed text-left text-primary">
            {t("about_me")}
          </p>
        </div>

        {/* Contact Button */}
        <div className="flex justify-center mt-8 md:mt-12">
          <button 
            onClick={scrollToContact}
            className="px-8 py-2 mb-20 text-lg rounded-full border-2 md:px-12 md:py-3 md:text-2xl border-border bg-background hover-element focus:outline-none"
          >
            {t("contact me")}
          </button>
        </div>
      </div>
    </Section>
  );
};

export default AboutSection;
